import React from 'react';
import { textblocks } from 'seal-ui-components';
import styled from 'styled-components';
import style from './BoldLabel.style';

const BoldLabel = ({ children, className, ...rest }) => (
    <textblocks.Heading4 {...rest} className={className}>
        {children}
    </textblocks.Heading4>
);

export default styled(BoldLabel)`
    ${style};
`;
